import React, { Component } from 'react';
import T from 'components/common/translations/Translate';

class PricesContent extends Component {
  render() {
    return (
      <div className="content">
        <h2><T>content.homepage.title</T></h2>
        <p><T>content.homepage.content</T></p>
      </div>
    );
  }
}

export default PricesContent;
